import React, { useEffect, useState } from 'react';

import IconButton from '@mui/material/IconButton';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import SelectModal from '../../../Components/Modal/SelectModal';

// Component
const ListTreeView = (props) => {
    //State
    const [confirmModal, setConfirmModal] = useState(false);

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', p: 0.5, pr: 0, borderRadius: 10,my:1}}>
                <Typography sx={{fontSize: '0.9rem',fontWeight: '500', textAlign: 'left', color:'#5f5600ff','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}>
                    {props.nodes.value}
                    {(props.nodes.enum) && <span>{` [${props.nodes.enum}]`}</span>}
                </Typography>
                <Box>
                    {(props.mode == 'edit' && !props.nodes.isClass) &&
                        <IconButton aria-label="add" sx={{color:'#5f5600ff', fontSize:'1rem'}} onClick={() => { setConfirmModal(!confirmModal) }}>
                            <AddCircleIcon sx={{fontSize:'1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'}}}/>
                        </IconButton>
                    }
                    {(props.mode == 'edit' && props.nodes.isClass) &&
                        <IconButton aria-label="cancel" color="error" onClick={props.pressButton} >
                            <CancelIcon  sx={{fontSize:'1rem','@media (min-width: 1636px)': {fontSize: '1.4rem'}}}/>
                        </IconButton>
                    }
                </Box>
            </Box>
            <SelectModal
                visible={confirmModal}
                title={props.modelTitle}
                options={props.modelOptions}
                changeValue={(val) => { props.changeMenuItem(val) }}
            />
        </>
    );
}
export default ListTreeView;